import { get } from 'lodash'
import PageHomepage from '~/themes/base/components/shop/PageHomepage/PageHomepage'
import Slider from '@theme/components/content/Slider'
import Story from '@theme/components/content/Story/StoryLazy'

export default {
  extends: PageHomepage,
  components: {
    Story,
  },
  data() {
    return {
      sideBanner: false,
    }
  },
  computed: {
    criticalContentBreakpoints() {
      return get(this.$themeSettings, 'components.Slider.image.srcsetBreakpoints').length
        ? this.$themeSettings.components.Slider.image.srcsetBreakpoints
        : Slider.extends.props.srcsetBreakpointsDefaults.default(this.$themeSettings)
    },
  },
}
